<div class="all-view" style="display:flex;flex-direction:column;height:100%;overflow:hidden;">

  <div class="all-toolbar">
    <div class="seg">
      <button [class.on]="filter === 'all'" (click)="filter = 'all'">All ({{ rows.length }})</button>
      <button [class.on]="filter === 'new'" (click)="filter = 'new'">New ({{ newCount }})</button>
      <button [class.on]="filter === 'replied'" (click)="filter = 'replied'">Replied ({{ repliedCount }})</button>
      <button [class.on]="filter === 'archived'" (click)="filter = 'archived'">Archived ({{ archivedCount }})</button>
    </div>
    <div style="flex:1;"></div>
    <button class="ghost" (click)="selectAll()" style="color:var(--txt);border:1px solid var(--border);background:#fff;padding:5px 10px;border-radius:6px;font-size:12px;cursor:pointer;">
      {{ allSelected ? '☑ Deselect all' : '☐ Select all' }}
    </button>
    <button class="ghost" (click)="archiveSelected()" [disabled]="!someSelected" style="color:var(--txt);border:1px solid var(--border);background:#fff;padding:5px 10px;border-radius:6px;font-size:12px;cursor:pointer;margin-left:4px;">🗄 Archive selected</button>
  </div>

  <div class="all-loading" *ngIf="loading" style="padding:24px;text-align:center;color:var(--muted);font-size:13px;">Loading…</div>
  <div class="all-error" *ngIf="!loading && loadError" style="padding:24px;text-align:center;color:#c0392b;font-size:13px;">{{ loadError }}</div>
  <div class="all-empty" *ngIf="!loading && !loadError && rows.length === 0" style="padding:24px;text-align:center;color:var(--muted);font-size:13px;">No messages found.</div>

  <div class="all-list" style="flex:1;overflow-y:auto;">
    <div *ngFor="let row of filteredRows" class="all-row" [class.new]="row.isNew" [class.selected]="row.isSelected">
      <input type="checkbox" [checked]="row.isSelected" (change)="toggleSelection(row)">
      <div class="ch-icon" [title]="row.senderName">{{ row.channelIcon }}</div>
      <div class="sender">{{ row.senderName }}</div>
      <div class="preview-txt"><b>{{ row.subject }}</b><span *ngIf="row.subject && row.preview"> — </span>{{ row.preview }}</div>
      <div class="status-pill" [ngClass]="statusPillClass(row.status)">{{ statusLabel(row.status) }}</div>
      <div class="t">{{ row.timestamp }}</div>
    </div>

    <div *ngIf="hasMore && !loading" style="padding:12px;text-align:center;">
      <button (click)="loadMore()" [disabled]="loadingMore" style="padding:6px 16px;border:1px solid var(--border);border-radius:6px;background:#fff;cursor:pointer;font-size:12px;">
        {{ loadingMore ? 'Loading…' : 'Load more' }}
      </button>
    </div>
  </div>

</div>
